module.exports = __webpack_public_path__ + "static/media/hotel2.2183c445.png";